// @ actions
const signaturePatternActions = require('actions/signaturePattern');

// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const { isPrintOfficeMode } = require("utilities/contactCenter/printerHelper");

// @ commons
const { nonNumericFilter } = require('utilities/stringHelper');

// @ constants
const actionTypes = require('constants/actionTypes');
const { R42_CARD_ON } = require('constants/cardR42States');
const TRAVEL_PLUS_STATUS_ON = 'E';
const TRAVEL_PLUS_STATUS_OFF = 'A';

//This actions are only for Contact Center wrap up purpose
const hireTravelPlusCCWrapUpOnStart = () => ({
    type: actionTypes.HIRE_TRAVEL_PLUS_CC_WRAP_UP_ON_START,
});

const hireTravelPlusCCWrapUpOffStart = () => ({
    type: actionTypes.HIRE_TRAVEL_PLUS_CC_WRAP_UP_OFF_START,
});

const hireTravelPlusCCWrapUpOnSuccess = () => ({
    type: actionTypes.HIRE_TRAVEL_PLUS_CC_WRAP_UP_ON_SUCCESS,
});

const hireTravelPlusCCWrapUpOffSuccess = () => ({
    type: actionTypes.HIRE_TRAVEL_PLUS_CC_WRAP_UP_OFF_SUCCESS,
});

const hireTravelPlusCCWrapUpOnFailure = errorMsg => ({
    type: actionTypes.HIRE_TRAVEL_PLUS_CC_WRAP_UP_ON_FAILURE,
    payload: {
        errorMsg,
    }
});

const hireTravelPlusCCWrapUpOffFailure = errorMsg => ({
    type: actionTypes.HIRE_TRAVEL_PLUS_CC_WRAP_UP_OFF_FAILURE,
    payload: {
        errorMsg,
    }
});

const reset = () => ({
    type: actionTypes.HIRE_TRAVEL_PLUS_RESET,
});

const hireTravelPlusRequest = () => ({
    type: actionTypes.HIRE_TRAVEL_PLUS_REQUEST,
});

const hireTravelPlusSuccessAction = response => ({
    type: actionTypes.HIRE_TRAVEL_PLUS_SUCCESS,
    payload: {
        response,
    }
});

const hireTravelPlusSuccess = (response, changeStatus, isActivationWizard) => dispatch => {
    if (__CONTACT_CENTER__ && !isActivationWizard) {
        if (changeStatus === TRAVEL_PLUS_STATUS_ON) {
            dispatch(hireTravelPlusCCWrapUpOnSuccess());
        } else {
            dispatch(hireTravelPlusCCWrapUpOffSuccess());
        }
    }

    dispatch(hireTravelPlusSuccessAction(response));
}

const hireTravelPlusFailureAction = errorMsg => ({
    type: actionTypes.HIRE_TRAVEL_PLUS_FAILURE,
    payload: {
        errorMsg,
    }
});

const hireTravelPlusFailure = (errorMsg, changeStatus, isActivationWizard) => dispatch => {
    if (__CONTACT_CENTER__ && !isActivationWizard) {
        if (changeStatus === TRAVEL_PLUS_STATUS_ON) {
            dispatch(hireTravelPlusCCWrapUpOnFailure(errorMsg));
        } else {
            dispatch(hireTravelPlusCCWrapUpOffFailure(errorMsg));
        }
    }

    dispatch(hireTravelPlusFailureAction(errorMsg));
}

const setTravelPlus = (cardId, token, newStatus, isActivationWizard) => (dispatch, getState) => {
    const immCard = getState().cards.getIn(['byId', cardId]);
    const immProfile = getState().profile;
    const requestData = {
        header: {
            version: 2,
        },
        query: {
            changeStatus: !!newStatus ? newStatus : TRAVEL_PLUS_STATUS_ON,
            contract: {
              numeroContrato: immCard.getIn(['contract', 'number']),
              producto: immCard.getIn(['contract', 'product']),
            },
            name: immCard.get('titularName'),
            pan: nonNumericFilter(immCard.get('number')),
            residenceNumber: immProfile.get('numDomicilio'),
            standardRef: immCard.getIn(['product', 'standard']),
            token,
        }
    };

    dispatch(hireTravelPlusRequest());

    return APIPost({
        dispatch,
        endpoint: 'travelPlusHire',
        params: requestData,
    })
        .then(response => dispatch(hireTravelPlusSuccess(response, requestData.query.changeStatus, isActivationWizard)))
        .catch(response => {
            if (!!response.error) {
                dispatch(hireTravelPlusFailure(response.error, requestData.query.changeStatus, isActivationWizard));
            }
            else {
                throw response;
            }
        });
};

const setTravelPlusWithSignaturePattern = cardId => (dispatch, getState) => {
    const callback = (dispatchSignature, getStateSignature, dataToken) => {
        const currentStatus = getStateSignature().cards.getIn(['byId', cardId, 'travelPlus', 'status']);

        let newStatus = TRAVEL_PLUS_STATUS_ON;

        if (currentStatus === R42_CARD_ON) {
            newStatus = TRAVEL_PLUS_STATUS_OFF;
        }

        dispatchSignature(setTravelPlus(cardId, dataToken, newStatus));
    };

    if (isPrintOfficeMode()) {
        const signaturePattern = getState().signaturePattern;
        const token = signaturePattern.get("token");
        callback(dispatch, getState, token);
    } else {
        new Promise(() => {
            signaturePatternActions.validateAndExecute(dispatch, getState, callback);
        });
    }
};

module.exports = {
    hireTravelPlusCCWrapUpOffStart,
    hireTravelPlusCCWrapUpOnFailure,
    hireTravelPlusCCWrapUpOnSuccess,
    hireTravelPlusCCWrapUpOnStart,
    reset,
    setTravelPlus,
    setTravelPlusWithSignaturePattern,
};